import { createStore, applyMiddleware, compose } from 'redux';

import thunk from 'redux-thunk';

const initialState = {
  currentUser: null,
}

export const selectors = {
  getCurrentUser: state => state.currentUser,
  getQuery: state => state.query,

}

const SET_USER = 'SET_USER';

export const actions = {
  setUser: user => ({
    type: SET_USER,
    user,
  }),
}

const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET_USER:
      return {
        ...state,
        currentUser: action.user,
      };

    default:
      return state;
  };
};


// const store = createStore(reducer, applyMiddleware(thunk));

const composeEnhancers =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }) : compose;

const enhancer = composeEnhancers(
    applyMiddleware(thunk),
    // other store enhancers if any
);
const store = createStore(reducer, enhancer);

export default store;
